import i18n from "i18n";
import FormInput from "../UI/FormInput";

const RoleInput = ({placeholder = i18n.t("role"),label = i18n.t("role"), helperText = null, maxLength = true }) => {
  const attr = maxLength ? { maxLength: 50 } : {};
  return (
    <FormInput
      label={label}
      placeholder={placeholder}
      id="role"
      type="text"
      autoComplete="role"
      required={true}
      attr={attr}
      helperText={helperText}
    />
  );
};
export default RoleInput;